<template>
  <div class="info-box">
    <div class="head-box">
      <p class="p1">{{ $t("user_center.account_setting.title") }}</p>
      <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/8.png" />
          <div>
            <p class="p3">
              {{ $t("user_center.account_setting.address.title") }}
            </p>
            <p class="p4 mt12">
              {{ $t("user_center.account_setting.address.tip") }}
            </p>
          </div>
        </div>
        <div class="item-btn">
          <div class="btn1" @click="addAssetClick">
            {{ $t("user_center.account_setting.add") }}
          </div>
          <div class="btn2" @click="assetListClick">
            {{ $t("user_center.account_setting.manage") }}
          </div>
        </div>
      </div>
      <!-- <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/9.png" />
          <div>
            <p class="p3">
              {{ $t("user_center.account_setting.receipt.title") }}
            </p>
            <p class="p4 mt12">
              {{ $t("user_center.account_setting.receipt.tip") }}
            </p>
          </div>
        </div>
        <div class="item-btn">
          <div class="btn1">{{ $t("user_center.account_setting.add") }}</div>
          <div class="btn2">{{ $t("user_center.account_setting.manage") }}</div>
        </div>
      </div> -->
    </div>
    <p class="p1 mt40">{{ $t("user_center.login_text") }}</p>
    <div class="tab-box">
      <div :class="{ sel: tableShow === 'login' }" @click="tabChange('login')">
        {{ $t("user_center.login_history") }}
      </div>
      <div
        :class="{ sel: tableShow === 'setting' }"
        @click="tabChange('setting')"
      >
        {{ $t("user_center.login_safety_history") }}
      </div>
    </div>
    <div class="box2 c-flex1 c-flex-column" v-if="tableShow === 'login'">
      <el-table
        :data="loginTable"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
      >
        <el-table-column prop="address" :label="$t('user_center.table.setting_history.time')">
          <template slot-scope="scope">
            {{
              dateFormatter(
                new Date(scope.row.createTime),
                "yyyy-MM-dd hh:mm:ss",
              )
            }}
          </template>
        </el-table-column>
        <el-table-column prop="source" :label="$t('user_center.table.login_recently.type')" />
        <el-table-column prop="address" :label="$t('user_center.table.login_recently.address1')">
          <template slot-scope="scope">
            {{ formatLoginAddress(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="$t('user_center.table.login_recently.status1')">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status" type="danger">{{ $t('user_center.table.login_recently.success1') }}</el-tag>
            <el-tag v-else type="warning">{{ $t('user_center.table.login_recently.error') }}</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="loginTotal > 0"
        class="pagination-box"
        background
        layout="prev, pager, next"
        :total="loginTotal"
        :page-size="loginFilter.pageSize"
        :current-page="loginFilter.pageNumber"
        @current-change="loginPageChange"
      />
    </div>
    <div class="box2 c-flex1 c-flex-column" v-if="tableShow === 'setting'">
      <el-table
        :data="settingTable"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
      >
        <el-table-column :label="$t('user_center.table.setting_history.time')">
          <template slot-scope="scope">
            {{
              dateFormatter(
                new Date(scope.row.createTime),
                "yyyy-MM-dd hh:mm:ss",
              )
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="operateType"
          :label="$t('user_center.table.setting_history.safe_setting')"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="sourceIp" label="IP" align="center">
        </el-table-column>
        <el-table-column
          :label="$t('user_center.table.setting_history.address')"
        >
          <template slot-scope="scope">
            {{ formatLoginAddress(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="settingTotal > 0"
        class="pagination-box"
        background
        layout="prev, pager, next"
        :total="settingTotal"
        :page-size="settingFilter.pageSize"
        :current-page="settingFilter.pageNumber"
        @current-change="settingPageChange"
      />
    </div>
    <AddAsset ref="addAssetRef" />
    <AssetList ref="assetListRef" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import AddAsset from "@/components/Dialog/AddAsset.vue";
import AssetList from "@/components/Dialog/AssetList.vue";
export default {
  data() {
    return {
      tableShow: "login",
      loginFilter: {
        pageNumber: 1,
        pageSize: 15,
      },
      loginTable: [],
      loginTotal: 0,
      settingFilter: {
        pageNumber: 1,
        pageSize: 15,
      },
      settingTable: [],
      settingTotal: 0,
    };
  },
  components: {
    AddAsset,
    AssetList,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  mounted() {
    this.getLoginTable();
    this.getSettingTable();
  },
  methods: {
    // 登录地址展示：后端返回中文"未知"时替换为国际化文案，其余原样显示
    formatLoginAddress(row) {
      const unknown = this.$t("user_center.table.login_recently.unknown");
      const country = row.country === "未知" ? unknown : row.country;
      const address = row.address === "未知" ? unknown : row.address;
      return address ? country + "." + address : country;
    },
    addAssetClick() {
      this.$refs.addAssetRef.dialogVisible = true;
    },
    assetListClick() {
      this.$refs.assetListRef.init();
    },
    tabChange(val) {
      this.tableShow = val;
      if (val === "setting") {
        this.settingPageChange(1);
      } else {
        this.loginPageChange(1);
      }
    },
    getLoginTable() {
      this.$axios.post("/user/userSigninLogs", this.loginFilter).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.loginTable = res.data.data.rows;
          this.loginTotal = res.data.data.total;
        }
      });
    },
    loginPageChange(val) {
      this.loginFilter.pageNumber = val;
      this.getLoginTable();
    },
    settingPageChange(val) {
      this.settingFilter.pageNumber = val;
      this.getSettingTable();
    },
    getSettingTable() {
      this.$axios
        .post("/user/securitySettingLogs", this.settingFilter)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.settingTable = res.data.data.rows;
            this.settingTotal = res.data.data.total;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.info-box {
  padding: 40px;
  background: #ffffff;
  border-radius: 22px 22px 22px 22px;
  border: 1px solid var(--border-color);
  .head-box {
    padding-bottom: 36px;
    border-bottom: 1px solid #e2e3e3;
  }
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 24px;
    color: #333333;
  }
  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #333333;
  }
  .p4 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
  .btn1 {
    width: 112px;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: var(--primary-color);
  }
  .btn2 {
    width: 112px;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: var(--white-color);
  }
  .item-box {
    display: flex;
    margin-top: 32px;
    justify-content: space-between;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .item-btn {
      gap: 32px;
      display: flex;
      align-items: center;
    }
  }
}
.box2 {
  margin-top: 20px;
  /deep/.table-head {
    border-bottom: none !important;
    background: var(--table-header-bg);
  }
  /deep/.table-head:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  /deep/.table-head:last-child {
    border-radius: 0px 6px 6px 0px;
  }
  /deep/.table-cell {
    border: none;
  }
  /deep/ .el-table__body tr.current-row > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    cursor: pointer;
    background-color: color-mix(in srgb, var(--primary-color) 10%, transparent) !important;
  }
}
.pagination-box {
  text-align: center;
  // margin-top: 60px;
  // margin-bottom: 120px;
  // /deep/ .btn-prev,
  // /deep/ .btn-next,
  // /deep/ .number {
  //   width: 44px;
  //   height: 44px;
  //   line-height: 44px;
  //   background: #ffffff;
  //   box-shadow: 0px 3px 10px 1px rgba(180, 180, 180, 0.06);
  //   border-radius: 6px 6px 6px 6px;
  // }
  // /deep/ .active {
  //   background-color: var(--primary-color) !important;
  // }
}
.tab-box {
  gap: 40px;
  display: flex;
  border-bottom: 1px solid #e2e3e3;
  div {
    padding: 20px 0;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
  .sel {
    font-weight: 800;
    font-size: 18px;
    color: #333333;
    position: relative;
  }
  .sel::before {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    bottom: 0;
    border-bottom: 1px solid var(--primary-color);
  }
}
</style>
